import { connect } from 'react-redux'
import Wizard from './wizard'
import {
  getConflicts,
  getCurrentStep
} from '../../../../stores/conflict-resolution/conflict-resolution.selectors'

const mapStateToProps = state => {
  const conflicts = getConflicts(state)
  const step = getCurrentStep(state)
  return {
    step,
    onIntroScreen: step === 1,
    onResolutionScreen: step === 2,
    noMoreStudents: conflicts && conflicts.remaining === 0
  }
}

export default connect(
  mapStateToProps,
  null
)(Wizard)
